import { useEffect, useState } from 'react';
// @mui
import { Menu, Button, MenuItem, Typography } from '@mui/material';
import Iconify from '../iconify/Iconify';
import { useTranslation } from 'react-i18next';
// component

// ----------------------------------------------------------------------

const SORT_BY_OPTIONS = [
    { value: 'featured', label: 'Featured' },
    { value: 'newest', label: 'Newest' },
    { value: 'priceDesc', label: 'Price: High-Low' },
    { value: 'priceAsc', label: 'Price: Low-High' },
];

export default function FillterCabinet({
    title,
    arrSort = [],
    setValueSort,
    labelDisplay = 'label',
    valueEqual = 'id',
    defaultValue = '---',
    valueSort = null,
}) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(null);
    const [value, setValue] = useState({});

    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClose = (data) => {
        setOpen(null);
        setValue(data);
        setValueSort && setValueSort(data);
    };

    useEffect(() => {
        if (valueSort) {
            setValue(valueSort);
        }
    }, [valueSort]);

    return (
        <>
            <Button
                color="inherit"
                disableRipple
                onClick={handleOpen}
                endIcon={<Iconify icon={open ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} />}
            >
                {title ? title : '---'}:&nbsp;
                <Typography component="span" variant="subtitle2" sx={{ color: 'text.secondary' }}>
                    {value[labelDisplay] ? value[labelDisplay] : defaultValue}
                </Typography>
            </Button>
            <Menu
                keepMounted
                anchorEl={open}
                open={Boolean(open)}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {arrSort.length > 0 ? (
                    arrSort.map((option, index) => (
                        <MenuItem
                            key={index}
                            selected={option[valueEqual] === value[valueEqual]}
                            onClick={() => handleClose(option)}
                            sx={{ typography: 'body2' }}
                        >
                            {option[labelDisplay]}
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem selected={true} disabled sx={{ typography: 'body2' }}>
                        <Typography component="span" variant="body2" sx={{ color: 'text.error' }}>
                            {t('emty_data')}
                        </Typography>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}
